export const LEADING_SUMMARY_AMENDS_KEY = "leadingSummary"

export function getLeadingSummaryTaskId(scheduleId) {
    if (!scheduleId) return null
    return `${scheduleId}-${LEADING_SUMMARY_AMENDS_KEY}`
}

export function isLeadingSummaryTaskId(taskId, scheduleId) {
    const leadingSummaryTaskId = getLeadingSummaryTaskId(scheduleId)
    return Boolean(leadingSummaryTaskId) && taskId === leadingSummaryTaskId
}
